import React, {useState}  from 'react'
import {Container, Row, Col, Alert} from 'react-bootstrap'
import { css } from 'emotion'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPrint, faPaperPlane } from '@fortawesome/free-solid-svg-icons'

import Providers from 'app/deliveryTool/context/Providers'
import RoadMaps from 'app/deliveryTool/pages/printPlanning/RoadMaps'
import Filters from 'app/deliveryTool/components/filters/Filters'
import Layout from 'app/universal/layout/Layout'
import LeMoulinApi from 'app/universal/utils/LeMoulinApi'
import {Helmet} from "react-helmet";

const PrintPlanning = (props) => {

  const disableFilters = {orderType:1, deliveryType:1};
  const [isLoading, setIsLoading] = useState(false);
  // Résultat du dernier envoi : qui a reçu ses tournées, qui n'a rien reçu
  const [sendResult, setSendResult] = useState(null);

  const sendRoadmapsOnWorkchat = async () => {
    setIsLoading(true);
    setSendResult(null);
    let queryString   = require('query-string')
    let query         = queryString.parse(window.location.search);
    let deliveryDate  = query.date ? query.date : null;
    let deliveryManId = query.deliveryman ? query.deliveryman : null;
    try {
      const response = await LeMoulinApi.request.deliveryMan.sendRoadmapsOnWorkchat(deliveryDate, deliveryManId);
      setSendResult(response.data);
    } catch (error) {
      setSendResult({error: error?.response?.data?.message || "L'envoi aux livreurs a échoué."});
    }
    setIsLoading(false);
  }

  return (
    <Providers>
      <Layout>
        <Helmet>
          <title>Impression planning</title>
        </Helmet>
        <Container fluid={true} >
          <Row className='no-print'> 
            <Col xs={12} sm={8} className={css(styles.filterBlock)}>
              <Filters disableFilters={disableFilters} />
            </Col>
            <Col xs={12} sm={4} className={css(styles.action)}>
              {isLoading ? 
                <div className={css(styles.printDisable)}><FontAwesomeIcon icon={faPaperPlane} /> Envoi en cours ...</div>
              :
                <div className={css(styles.print)} onClick={() => sendRoadmapsOnWorkchat()}><FontAwesomeIcon icon={faPaperPlane} /> Envoyer aux livreurs</div>
              }
              <div className={css(styles.print)} onClick={() => window.print()}><FontAwesomeIcon icon={faPrint} /> Imprimer</div>
            </Col>
          </Row>
          {sendResult &&
            <Row className='no-print'>
              <Col xs={12}>
                <Alert
                  className={css(styles.result)}
                  variant={sendResult.error ? 'danger' : (sendResult.success ? 'success' : 'warning')}
                  dismissible
                  onClose={() => setSendResult(null)}
                >
                  {sendResult.error ?
                    sendResult.error
                  :
                    <>
                      <div>{(sendResult.sent || []).length} livreur(s) prévenu(s) en message privé Connecteam{(sendResult.sent || []).length > 0 && ' : ' + sendResult.sent.join(', ')}</div>
                      {(sendResult.notFound || []).length > 0 &&
                        <div><strong>Rien reçu, introuvables sur Connecteam :</strong> {sendResult.notFound.join(', ')}. Vérifier leur téléphone sur la fiche livreur du BO, ou les prévenir autrement.</div>
                      }
                      {(sendResult.failed || []).length > 0 &&
                        <div><strong>Rien reçu, échec de l'envoi :</strong> {sendResult.failed.join(', ')}. Réessayer plus tard.</div>
                      }
                    </>
                  }
                </Alert>
              </Col>
            </Row>
          }
        <RoadMaps router={props.history}/>
        </Container>
      </Layout>
    </Providers>
  )

}

const styles = {
  filterBlock:{
    'borderBottom': '1px #ddd solid',
    'padding': '10px 10px 10px 10px',
    "@media (max-width: 767px)": {
      'textAlign': 'center'
    }
  },
  action: {
    'borderBottom': '1px #ddd solid',
    'padding': '10px 10px 10px 10px',
    'textAlign': 'right',
    "@media (max-width: 767px)": {
      'textAlign': 'center'
    }
  },
  print: {
    display:'inline-block',
    border: 'thin solid #bbb',
    color: '#555',
    cursor: 'pointer',
    padding: '0.2rem 1rem',
    transition: '300ms',
    ':hover': {
      textDecoration: 'none',
      color: 'white',
      backgroundColor: '#bbb',
      transition: '300ms'
    }
  },
  result: {
    marginTop: '10px',
    marginBottom: 0
  },
  printDisable: {
    display:'inline-block',
    border: 'thin solid #bbb',
    color: '#555',
    padding: '0.2rem 1rem',
    transition: '300ms',
    opacity: 0.5
  }

}

export default PrintPlanning
